import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import robloxApi from '../../api/robloxApi';
import { CategoryInterface } from "../../store/roblox/categoriesSlice";

const PREFIX = 'roblox';

const processStrategy = (value: any) => {
  return {
    ...value
  };
}

const categoriesEntity = new schema.Entity(
  'categories',
  {},
  {
    processStrategy
  }
);

const categoryEntity = new schema.Entity(
  'category',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      category: CategoryInterface
    }
  >(response.data.category, categoryEntity);

  return normalized.entities;
}

const normalizeCollection = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      categories: { [key: string]: CategoryInterface };
    }
  >(response.data.categories, [categoriesEntity]);

  return {
    categories: normalized.entities?.categories || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchCategories = createAsyncThunk(
  `${PREFIX}_categories/fetchCategories`,
  async (params: object = {}) => {
    const response = await robloxApi.get(`/onesky/categories`, { params })

    return normalizeCollection(response);
  }
);

export const fetchCategory = createAsyncThunk(
  `${PREFIX}_categories/fetchCategory`,
  async (id: number) => {
    const response = await robloxApi.get(`/onesky/categories/${id}`)

    return normalizeInstance(response);
  }
);

export const createCategory = createAsyncThunk(
  `${PREFIX}_categories/createCategory`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await robloxApi.post(`/onesky/categories`, data)

      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateCategory = createAsyncThunk(
  `${PREFIX}_categories/updateCategory`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await robloxApi.patch(`/onesky/categories/${id}`, data)

      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyCategory = createAsyncThunk(
  `${PREFIX}_categories/destroyCategory`,
  async (id: number) => {
    const response = await robloxApi.delete(`/onesky/categories/${id}`)

    return response.data;
  }
);

export const reorderCategories = createAsyncThunk(
  `${PREFIX}_categories/reorderCategories`,
  async ({ ids }: { ids: any }, { rejectWithValue }) => {
    try {
      await robloxApi.patch('/onesky/categories/reorder', { ids })

      return { ids };
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
